<template>
  <div class="modal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Historial de cambios del porcentaje de eficiencia de la máquina</h5>
          <button type="button" @click="closeModal"
            style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
        </div>
        <div v-if="isLoading" style="padding: 5ch 0">
          <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
        </div>
        <div class="modal-body" v-else>
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="card-header-search-bar col-12">
                  <b-form-input v-model="filter" id="filter-input"
                    placeholder="Escriba aquí el texto a buscar"></b-form-input>
                </div>
                <br>
                <br>
                <div class="card-header-pagination col-7">
                  <b-pagination v-model="currentPage" :total-rows="filteredList ? filteredList.length : 0"
                    :per-page="perPage" aria-controls="list-table" style="margin: 0" align="center"></b-pagination>
                </div>
                <div class="card-header-action-buttons col-5">
                  <div>
                    <ButtonComponent :buttonText="'Refrescar'" :buttonColor="colors.BLUE_COLOR_BUTTON"
                      :buttonAction="loadMachineEfficiencyPctHistory" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isLoading" style="padding: 5ch 0">
              <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
            </div>
            <div class="card-body" v-else>
              <b-table :items="filteredList" :fields="fields" small striped hover :per-page="perPage"
                :current-page="currentPage" id="efficiency_pct-history-list-table">
                <template #cell(updated_at)="data">
                  {{ new Date(data.item.updated_at).toLocaleString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(' ', ' ') }}
                </template>
                <template #cell(efficiency_pct_value)="data">
                  {{ data.item.efficiency_pct_value }}
                </template>
              </b-table>
            </div>
          </div>
          <hr>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-danger me-2" @click="closeModal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Colors from '../../common/colors';
import axios from 'axios';
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import ButtonComponent from "../../common/components/ButtonComponent.vue";
import { filterList } from '../../common/utils';

export default {
  name: 'MachineHistoryModal',
  components: {
    SpeenComponent,
    ButtonComponent
  },
  props: {
    machineId: { type: Number, required: true }
  },
  data() {
    return {
      colors: Colors,
      isLoading: true,
      perPage: 5,
      currentPage: 1,
      filter: '',
      listData: [],
      fields: [
        { key: "updated_at", label: "Fecha",     sortable: true, class: "truncate" },
        { key: "updated_by", label: "Usuario",   sortable: true, class: "truncate" },
        { key: "efficiency_pct_value",  label: "% Eficiencia", sortable: true, class: "truncate" },
      ],
    };
  },
  computed: {
    filteredList: function () {
      return filterList(this.listData, this.fields, this.filter);
    },
  },
  methods: {
    loadMachineEfficiencyPctHistory() {
      this.isLoading = true;
      axios.get(`/api/machine/${this.machineId}/efficiency-pct-history`)
        .then(response => {
          this.listData = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeModal() {
      this.$emit('close-modal');
    },
  },
  mounted() {
    this.loadMachineEfficiencyPctHistory();
  }
};
</script>
